import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OroService } from '../oro.service';

import { ContactUsResult } from '../domain/ContactUsResult';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {


  isDisabled = false;

  public ContactUs: string = '';

  constructor(private router: Router, private oroService: OroService) { }

  ngOnInit(): void {

    console.log('contact-us.component');

    this.oroService.contactUsHub<ContactUsResult>('Hub').subscribe(
      (result: ContactUsResult) => {
        if (result.Success) {

          this.ContactUs = result.ContactUs;
        } else {
          alert(result.Message);
        }
      }
    );
}

  gotoHub() {

    this.isDisabled = true;
    this.router.navigateByUrl('/hub');
  }

}
